import { render, staticRenderFns } from "./Ddcx-detail.vue?vue&type=template&id=213fbd37&scoped=true"
import script from "./Ddcx-detail.vue?vue&type=script&lang=js"
export * from "./Ddcx-detail.vue?vue&type=script&lang=js"
import style0 from "./Ddcx-detail.vue?vue&type=style&index=0&id=213fbd37&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213fbd37",
  null
  
)

export default component.exports